import { List } from '@zillow/constellation';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <List paddingLeft="md">
        <List.Item> We&apos;ll deliver renter inquiries to the email you provide here.</List.Item>
        <List.Item>Other communications from Zillow will be sent to your account email.</List.Item>
      </List>
    </div>
  );
};

export default WizardTipContent;
